<template>
  <div id="SendMessageToAdmin">
    <net-pa-list-page-card
      :title="pageTitle"
      :description="pageDescription"
      :show-back="true"
    >
      <div class="send-message-form">
        <div class="row">
          <div
            class="col-md-4 col-12 send-message-field"
            v-if="isShowDateTimePicker == true"
          >
            <label class="send-message-field-label">تاریخ حضور</label>
            <date-picker
              :editable="false"
              :auto-submit="true"
              color="#435ebe"
              v-model="datetime"
              type="datetime"
            >
            </date-picker>
          </div>
          <div class="col-12 send-message-field">
            <label class="send-message-field-label">متن پیام خود را بنویسید</label>
            <textarea
              class="form-control"
              @keypress="$BlockSuspiciousInput($event)"
              @keyup="$BlockSuspiciousInput($event)"
              rows="2"
              ref="textarea"
              @input="adjustHeight"
              v-model="Txt"
            >
            </textarea>
          </div>
        </div>
        <div class="send-message-actions">
          <div class="send-message-actions__captcha">
            <CaptchaBox
              ref="captchaRef"
              :width="160"
              :height="40"
              @update="onCaptchaValid"
            ></CaptchaBox>
          </div>
          <button
            class="btn btn-success rounded send-message-actions__btn"
            @click="SendMessage"
            :disabled="!CaptchaValid"
          >
            <i class="fas fa-paper-plane" aria-hidden="true"></i> ارسال پیام
          </button>
        </div>
      </div>
    </net-pa-list-page-card>
  </div>
</template>
<script>
import NetPaListPageCard from "../Tools/NetPa/NetPaListPageCard.vue";
import CaptchaBox from "../CmpLogin/CaptchaBox.vue";

export default {
  data() {
    return {
      datetime: this.$GetJalaliDateTime(),
      Txt: "",
      DataAxiosRow: {
        ArryfildValue: "",
        Method: "Post",
        Action: "InsAzaMessage",
        Token: "",
      },
      CaptchaValid: false,
      captchaText: "",
      captchaId: "",
    };
  },
  components: { NetPaListPageCard, CaptchaBox },
  computed: {
    pageTitle() {
      return this.$GetIsAnbohSaz()
        ? "فرم ارتباط با مدیر"
        : "فرم درخواست حضوری";
    },
    pageDescription() {
      return this.$GetIsAnbohSaz()
        ? "از طریق این فرم می توانید پیامی در قالب متن را به مدیر سامانه ارسال نمایید."
        : "";
    },
  },
  methods: {
    refreshCaptcha() {
      this.$refs.captchaRef.generateCaptcha();
    },
    SendMessage() {
      if (this.isShowDateTimePicker == true) {
        this.Txt +=
          this.Txt + " \n [ " + " درخواست حضور برای : " + this.datetime + " ] ";
      }
      const formData = new FormData();
      formData.append(
        "wwwtblAzaId",
        this.$session.get("UserInfoNetPa").wwwtblAzaId,
      );
      formData.append(
        "wwwtblShobeId",
        this.$session.get("UserInfoNetPa").wwwtblShobeId,
      );
      formData.append("Message", this.Txt);
      formData.append("ZamanInsert", this.$GetJalaliDateTime());
      formData.append("userInput", this.captchaText);
      formData.append("captchaId", this.captchaId);
      this.DataAxiosRow.ArryfildValue = formData;
      this.DataAxiosRow.Token = this.$session.get("TokenNetPa");
      this.$PostFormData(this.DataAxiosRow).then((data) => {
        console.log(data);
        if (data.status == "NotOk") {
          this.refreshCaptcha();
          this.$mySweetDefault(
            "خطا",
            "کد یکبار مصرف اشتباه است",
            "error",
            3000,
          );
          return;
        }
        if (data.result == "SUCCESS") {
          this.$mySweetDefault(
            "عملیات موفق",
            "ارسال پیام با موفقیت انجام شد",
            "success",
            3000,
          );
          this.Txt = "";
        } else {
          this.$mySweetDefault(
            "خطایی رخ داده است",
            "در ارسال پیام خطایی رخ داده است",
            "error",
            3000,
          );
        }
      });
    },

    adjustHeight() {
      const textarea = this.$refs.textarea;
      textarea.style.height = "auto";
      textarea.style.height = `${textarea.scrollHeight}px`;
    },
    onCaptchaValid({ valid, captchaId, userInput }) {
      this.CaptchaValid = valid;
      this.captchaId = captchaId;
      this.captchaText = userInput;
    },
  },
  props: ["isShowDateTimePicker"],
  created() {
    // console.log(this.isShowDateTimePicker)
  },
};
</script>
<style>
#SendMessageToAdmin .send-message-form {
  padding: 0.75rem 1rem 1rem;
}

#SendMessageToAdmin .send-message-field {
  margin-bottom: 0.75rem;
}

#SendMessageToAdmin .send-message-field-label {
  display: block;
  margin-bottom: 0.35rem;
  font-family: IRANSansWeb, Tahoma, Arial, sans-serif;
  font-size: 13px;
  font-weight: 600;
  color: #2a3f54;
}

#SendMessageToAdmin .send-message-actions {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: flex-end;
  gap: 0.75rem;
  width: 100%;
  margin-top: 0.5rem;
  padding-top: 0.875rem;
  border-top: 1px solid #e8ecf1;
  box-sizing: border-box;
}

#SendMessageToAdmin .send-message-actions__captcha {
  flex: 1 1 22rem;
  min-width: 20rem;
  max-width: 32rem;
}

#SendMessageToAdmin .send-message-actions__captcha .input-group {
  margin-bottom: 0 !important;
  flex-wrap: nowrap !important;
}

#SendMessageToAdmin .send-message-actions__btn {
  flex: 0 0 auto;
  min-width: 160px;
  height: 40px;
  font-family: IRANSansWeb, Tahoma, Arial, sans-serif;
  font-weight: 600;
}

@media (max-width: 575px) {
  #SendMessageToAdmin .send-message-actions {
    flex-direction: column;
    align-items: stretch;
  }

  #SendMessageToAdmin .send-message-actions__captcha {
    flex: none;
    width: 100%;
    min-width: 0;
    max-width: none;
  }

  #SendMessageToAdmin .send-message-actions__btn {
    width: 100%;
  }
}
</style>
